import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Draggable from 'react-draggable';
import ApiEngine from "../../util/ApiEngine.js";
import { isEmpty, map } from "lodash";
import { useHistory, withRouter } from "react-router-dom";
import {
    WebUrl,
    ApiUrl,
    ApiKey,
    LanguageOption,
    SessionKey,
    Language,
    AlertTypes,
    DisplayDevice,
    _MAIN_WALLET_ID,
    KEY,
    PhoneNumberPrefix,
    TransactionType
} from "../../util/Constant";
import {
    Alert,
    Modal,
    ModalBody,
    ModalHeader,
    Nav,
    NavItem,
    NavLink,
    Spinner,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import moment from "moment";
import { setBusy, setDisplayLogin, setDisplayRegister, setIdle, showMessage, showResponseMessage } from "../../redux/AppAction.js";
import {
    startGame
} from "../../redux/GameAction.js";

const CustomMiniGames = (props) => {
    var _dispatch = useDispatch();
    const { t } = useTranslation();
    const _userData = useSelector((state) => state.authState.userData);
    const [controlledPosition, setControlledPosition] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [openMiniGameModal, setOpenMiniGameModal] = useState(false);
    const [activeLanguage, setActiveLanguage] = useState("id");
    const [startGameTime, setStartGameTime] = useState("");
    const [coinMiniGameUrl, setCoinMiniGameUrl] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const miniGameRef = useRef(null);
    const miniGameCloseButtonRef = useRef(null);
    const [currentActiveTab, setCurrentActiveTab] = useState("COINMINI");
    const [kenoMiniGameUrl, setKenoMiniGameUrl] = useState("");
    const [taiXiuMiniGameUrl, setTaiXiuMiniGameUrl] = useState("");
    const [miniGamesFirstClicked, setMiniGamesFirstClicked] = useState(["COINMINI"]);
    const [showMiniGameTrigger, setShowMiniGameTrigger] = useState(JSON.parse(localStorage.getItem(SessionKey._ISSHOWMINIGAMETRIGGER)));
    const delayTime = 4000;
  const { isLoggedIn } = useSelector((state) => state.authState);
  const games93Connect = useSelector((state) => state.appState.games93Connect);
  const gameProviders = useSelector((state) => state.gameState.gameProviders);
    const [isSpecialRollover, setIsSpecialRollover] = useState(false);

    const [playableCategory, setPlayableCategory] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [gameAppUrl, setGameAppUrl] = useState("");
    const [gameAppDeepLink, setGameAppDeepLink] = useState("");
    const [gameAppPackageNameKeyword, setGameAppPackageNameKeyword] = useState("");
    const [mpData, setMpData] = useState([]);
    const _history = useHistory();

    const toggle = tab => {
        if (currentActiveTab !== tab) {
            if (startGameTime != "") {
                const withinSecond = new Date().getTime() - startGameTime < delayTime;
                if (miniGamesFirstClicked.indexOf(tab) == -1) {
                    if (!withinSecond) {
                        setCurrentActiveTab(tab);
                        setIsLoading(true);
                        startMiniGame(tab, 'd');
                        setTimeout(function () {
                            setMiniGamesFirstClicked([...miniGamesFirstClicked, tab]);
                            setIsLoading(false);
                        }, delayTime);
                    }
                }
                else if (miniGamesFirstClicked.indexOf(currentActiveTab) != -1) {
                    setCurrentActiveTab(tab);
                }
            }
        }
    }
    const onControlledDrag = (e, position) => {
        const { x, y } = position;
        setControlledPosition({ x, y });
    }

    useEffect(() => {
    }, []);

    async function startMiniGame(miniGameCode, device) {

        // mini game have their own lang id
        let miniGameLangId = 0;

        if (activeLanguage == "en" || activeLanguage == "id") {
            miniGameLangId = 0;
        }
        else if (activeLanguage == "zh") {
            miniGameLangId = 1;
        }
        else if (activeLanguage == "ms") {
            miniGameLangId = 2;
        }
        else if (activeLanguage == "vi") {
            miniGameLangId = 3;
        }
        else if (activeLanguage == "th") {
            miniGameLangId = 4;
        }

        setStartGameTime("");
        var responseJson = await ApiEngine.get(ApiUrl._API_GET_MINI_GAME_URL +
            "?miniGameCode=" + miniGameCode +
            "&device=" + device +
            "&languageId=" + miniGameLangId
        );

        if (!responseJson[ApiKey._API_SUCCESS_KEY]) {
            throw responseJson[ApiKey._API_MESSAGE_KEY];
        }
        else {
            let data = responseJson[ApiKey._API_DATA_KEY];
            if (miniGameCode == "COINMINI") {
                setCoinMiniGameUrl(data);
                setStartGameTime(moment());
                setTimeout(function () {
                    setIsLoading(false);
                }, 3000);
            }
            else if (miniGameCode == "KENOMINI") {
                setKenoMiniGameUrl(data);
                setStartGameTime(moment());
            }
            else {
                setTaiXiuMiniGameUrl(data);
                setStartGameTime(moment());
            }
        }
    }

    return (
        <>
            {showMiniGameTrigger &&
                <>
                <Draggable
                    bounds={{ left: 0, top: 250 - window.screen.height, right: 0, bottom: 0 }}
                    onDrag={(e, position) => {
                        onControlledDrag(e, position);
                        setIsDragging(true);
                    }}
                    onStop={() => {
                        if (!isDragging) {
                            setOpenMiniGameModal(true);
                            startMiniGame(currentActiveTab, "m");
                        }
                        setIsDragging(false)
                    }}
                >

                    <div className="cny-pop-trigger" ref={miniGameRef}>
                        <img
                          src={"/img/new-mini-games/Web_" + (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined'
                                ? localStorage.getItem(SessionKey._LANGUAGE)
                                : 'id')
                            + ".png"}
                            alt="Mini Games"
                        />
                    </div>
                </Draggable>

            


            <Draggable
                bounds="body"
                position={controlledPosition}
                onStop={() => {
                    setShowMiniGameTrigger(false);
                    localStorage.setItem(SessionKey._ISSHOWMINIGAMETRIGGER, false);
                }}
            >
                <div className="cny-pop-trigger" ref={miniGameCloseButtonRef}>
                    <div className="cny-trigger-close">
                        <img src={"/img/cny/Close_Icon.svg"} style={{ width: "20px" }} width="100%" height="100%" />
                    </div>
                </div>
                </Draggable>

            </>
            }

            {openMiniGameModal && (
                //<div className="cny-video">
                //    <div className="cny-video-box">
                //        <div className="mini-games-modal">
                //            <div className="mini-games-dialog">
                //                <div className="mini-games-header">
                //                    <img src={require("../../img/new-mini-games/Web_"
                //                        + (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined'
                //                            ? localStorage.getItem(SessionKey._LANGUAGE)
                //                      : 'id')
                //                        + ".png")}
                //                        width="49.5%" height="100%"
                //                    />
                //                    <button className="mini-close-button"
                //                        onClick={() => {
                //                            setOpenMiniGameModal(false);
                //                            setCoinMiniGameUrl("");
                //                            setKenoMiniGameUrl("");
                //                            setTaiXiuMiniGameUrl("");
                //                            setCurrentActiveTab("COINMINI");
                //                            setMiniGamesFirstClicked(["COINMINI"]);
                //                            setIsLoading(true);
                //                        }}
                //                    ></button>
                //                </div>
                //                <div className="mini-games-body">
                //                    <Nav tabs className="mini-games-tab">
                //                        <NavItem>
                //                            <NavLink
                //                                className={
                //                                    "mini-games-items " +
                //                                    classnames({
                //                                        selected:
                //                                            currentActiveTab === "KENOMINI"
                //                                    })}
                //                                onClick={() => {
                //                                    toggle("KENOMINI");
                //                                }}
                //                            >
                //                                <img
                //                                    src={"/img/mini-games/gameIcon/KenoMini-Icon.png"}
                //                                    loading="lazy" />
                //                            </NavLink>
                //                        </NavItem>
                //                        <NavItem>
                //                            <NavLink
                //                                className={
                //                                    "mini-games-items " +
                //                                    classnames({
                //                                        selected:
                //                                            currentActiveTab === "COINMINI"
                //                                    })}
                //                                onClick={() => {
                //                                    toggle("COINMINI");
                //                                }}
                //                            >
                //                                <img
                //                                    src={"/img/mini-games/gameIcon/CoinMini.png"}
                //                                    loading="lazy" />
                //                            </NavLink>
                //                        </NavItem>
                //                        <NavItem>
                //                            <NavLink
                //                                className={
                //                                    "mini-games-items " +
                //                                    classnames({
                //                                        selected:
                //                                            currentActiveTab === 'TAIXIUMINI'
                //                                    })}
                //                                onClick={() => {
                //                                    toggle('TAIXIUMINI');
                //                                }}
                //                            >
                //                                <img
                //                                    src={"/img/mini-games/gameIcon/TaiXiumini.png"}
                //                                    loading="lazy" />
                //                            </NavLink>
                //                        </NavItem>
                //                    </Nav>

                //                    <TabContent
                //                        activeTab={currentActiveTab}
                //                        className="mini-games-section"
                //                    >
                //                        <TabPane
                //                            tabId="KENOMINI"
                //                            className="mini-games-content"
                //                            style={currentActiveTab === 'KENOMINI' ? { display: "block !important" } : { display: "none !important", opacity: 0 }
                //                            }>
                //                            <div id="KENOMINI" className="mini-games-content">
                //                                {
                //                                    isLoading &&
                //                                    <div className="loading">
                //                                        <Spinner animation="border" role="status"></Spinner>
                //                                    </div>
                //                                }
                //                                <iframe
                //                                    className="iframe"
                //                                    loading="lazy"
                //                                    frameBorder="0"
                //                                    width="248"
                //                                    height="227"
                //                                    title="Keno Mini"
                //                                    src={kenoMiniGameUrl}
                //                                >
                //                                </iframe>
                //                            </div>
                //                        </TabPane>
                //                        <TabPane
                //                            tabId="COINMINI"
                //                            className="mini-games-content"
                //                            style={currentActiveTab === 'COINMINI' ? { display: "block !important" } : { display: "none !important", opacity: 0 }}>
                //                            <div id="COINMINI" className="mini-games-content">
                //                                {
                //                                    isLoading &&
                //                                    <div className="loading">
                //                                        <Spinner animation="border" role="status"></Spinner>
                //                                    </div>
                //                                }
                //                                <iframe
                //                                    className="iframe"
                //                                    loading="lazy"
                //                                    width="248"
                //                                    height="227"
                //                                    title="Coin Mini"
                //                                    src={coinMiniGameUrl}
                //                                >
                //                                </iframe>
                //                            </div>
                //                        </TabPane>
                //                        <TabPane
                //                            tabId="TAIXIUMINI"
                //                            className="mini-games-content"
                //                            style={currentActiveTab === 'TAIXIUMINI' ? { display: "block !important" } : { display: "none !important", opacity: 0 }}>
                //                            <div id="TAIXIUMINI" className="mini-games-content">
                //                                {
                //                                    isLoading &&
                //                                    <div className="loading">
                //                                        <Spinner animation="border" role="status"></Spinner>
                //                                    </div>
                //                                }
                //                                <iframe
                //                                    className="iframe"
                //                                    loading="lazy"
                //                                    frameBorder="0"
                //                                    width="248"
                //                                    height="227"
                //                                    title="TaiXiu Mini"
                //                                    src={taiXiuMiniGameUrl}
                //                                >
                //                                </iframe>
                //                            </div>
                //                        </TabPane>
                //                    </TabContent>
                //                    <div className="more-game-img"
                //                          onClick={() => {
                //                            if (Object.keys(games93Connect).length !== 0) {
                //                                _dispatch(startGame(games93Connect));
                //                            }
                //                        }}
                //                    >
                //                        <img src={require("../../img/mini-games/moreGames/more_games_"
                //                            + (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined'
                //                                ? localStorage.getItem(SessionKey._LANGUAGE)
                //                          : 'id')
                //                            + ".png")}
                //                        />
                //                    </div>
                //                </div>
                //            </div>
                //        </div>
                //    </div>
            //</div>
            <div className="mini-games-overlay">

              {/* Header */}
              <div className="mini-games-header">
                <img
                  src={"/img/new-mini-games/Web_"
                    + (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) !== 'undefined'
                      ? localStorage.getItem(SessionKey._LANGUAGE)
                      : 'en')
                    + ".png"} alt="mini game header"
                />

                <button
                  className="mini-games-close"
                  onClick={() => setOpenMiniGameModal(false)}
                >
                  ✕
                </button>
              </div>
              <div className="mini-games-container">
                {/* Game icons */}
                <div className="mini-games-icons">
                  <div
                    className={`mini-icon ${currentActiveTab === "KENOMINI" ? "active" : ""}`}
                    onClick={() => { setCurrentActiveTab("KENOMINI"); toggle("KENOMINI"); }}
                  >
                    <img src="/img/new-mini-games/KenoMini-Icon.png" loading="lazy" alt="KENOMINI" />
                  </div>

                  <div
                    className={`mini-icon ${currentActiveTab === "COINMINI" ? "active" : ""}`}
                    onClick={() => { setCurrentActiveTab("COINMINI"); toggle("COINMINI"); }}
                  >
                    <img src="/img/new-mini-games/CoinMini.png" loading="lazy" alt="COINMINI" />
                  </div>

                  <div
                    className={`mini-icon ${currentActiveTab === "TAIXIUMINI" ? "active" : ""}`}
                    onClick={() => { setCurrentActiveTab("TAIXIUMINI"); toggle("TAIXIUMINI"); }}
                  >
                    <img src="/img/new-mini-games/TaiXiumini.png" loading="lazy" alt="TAIXIUMINI" />
                  </div>
                  <div
                  style={{ alignSelf: 'center', width: '20px', textAlign: 'center', cursor: 'pointer' }}
                  onClick={() => _dispatch(startGame((gameProviders.filter(x => x.name === "93Connect")[0]).productGame))}
                  >
                    <img src="/img/new-mini-games/moreGames.svg" loading="lazy" alt="moreGames" />
                  </div>
                </div>

                {/* Game Preview */}
                <div className="mini-games-preview" id="mini-games-preview-id">
                  <iframe
                    src={
                      currentActiveTab === "COINMINI"
                        ? coinMiniGameUrl
                        : currentActiveTab === "KENOMINI"
                          ? kenoMiniGameUrl
                          : taiXiuMiniGameUrl
                    }
                    className="mini-games-iframe"
                    title="Mini Game"
                  />
                </div>
              </div>
            </div>

            )}
            
        </>
    )
}

export default CustomMiniGames;
